import React, { Component } from "react";
import styles from "./styles";
import * as images from "./images";

export default class ForbiddenView extends Component {
  render() {
    return (
      <div style={styles.wrapper}>
        <div>
          <img src={images.mascote} alt="Erro Inesperado  " />
          <h2>
            <strong>Oops!</strong> Erro Inesperado do sistema.
          </h2>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/generic-error/view.jsx